const ALLOWED_TAGS = new Set([
  "a", "b", "blockquote", "br", "code", "del", "div", "em", "h1", "h2", "h3",
  "hr", "i", "img", "li", "ol", "p", "pre", "s", "strike", "strong", "u", "ul",
]);
const DROP_CONTENT_TAGS = new Set(["iframe", "object", "script", "style", "svg", "template"]);

function safeUrl(value, protocols) {
  try {
    const parsed = new URL(value, window.location.href);
    return protocols.includes(parsed.protocol) ? parsed.href : "";
  } catch {
    return "";
  }
}

export function sanitizeResourceHtml(value = "") {
  const source = new DOMParser().parseFromString(String(value), "text/html");
  const output = document.createElement("div");

  const copyChildren = (sourceParent, targetParent) => {
    Array.from(sourceParent.childNodes).forEach((node) => {
      if (node.nodeType === 3) {
        targetParent.appendChild(document.createTextNode(node.nodeValue || ""));
        return;
      }
      if (node.nodeType !== 1) return;

      const tag = node.tagName.toLowerCase();
      if (DROP_CONTENT_TAGS.has(tag)) return;
      if (!ALLOWED_TAGS.has(tag)) {
        copyChildren(node, targetParent);
        return;
      }

      const safeElement = document.createElement(tag);
      if (tag === "a") {
        const href = safeUrl(node.getAttribute("href") || "", ["http:", "https:", "mailto:"]);
        if (href) {
          safeElement.setAttribute("href", href);
          safeElement.setAttribute("target", "_blank");
          safeElement.setAttribute("rel", "noopener noreferrer");
        }
      } else if (tag === "img") {
        const src = safeUrl(node.getAttribute("src") || "", ["http:", "https:"]);
        if (!src) return;
        safeElement.setAttribute("src", src);
        safeElement.setAttribute("alt", node.getAttribute("alt") || "");
      }

      targetParent.appendChild(safeElement);
      copyChildren(node, safeElement);
    });
  };

  copyChildren(source.body, output);
  return output.innerHTML;
}